// https =//www.figma.com/file/3yhtpRlrV1wZvHXJ4bnwMW/MigWiz-2021-UI-Kit?node-id=959%3A9907

/* eslint-disable object-shorthand */

const black = '#000000';
const white = '#FFFFFF';

const migWizPurple10 = '#F0E9FB';
const migWizPurple = '#6A27DB';
const migWizPurpleDark = '#321266';
const migWizPurple3 = '#FAF8FE';
const migWizPurple30 = '#D2BEF4';
const migWizPurple50 = '#B48FEF';
const migWizPurpleHalfDark = '#4E1CA0';
const chart3Queued = '#D9C8F7';
const chart4WaitingForUser = '#1EC7D0';
const stepperBarFill = '#8F57E7';
const redLight = '#FFF1F1';
const redMedium = '#FF5959';
const redDark = '#D62A1D';
const redExtraDark = '#A3211E';
const warningLight = '#FFF8E2';
const warningMedium = '#FFB95C';
const warningDark = '';
const infoLight = '#EEECFB';
const infoMedium = '#6A27DB';
const infoDark = '';
const successLight = '#D8FFE3';
const successMedium = '#57CE8F';
const successDark = '';
const grey50 = white;
const grey100 = '#F8F8F9';
const grey200 = '#F3F3F3';
const grey300 = '#EEEEEE';
const grey400 = '#DCDBDE';
const grey500 = '#CAC8CE';
const grey600 = '#86858E';
const grey700 = '#595862';
const grey800 = '#2f3137';
const grey900 = '#18191C';

export type Colors = {
  [key: string]: string;
};

const colors: Colors = {
  primaryLight: migWizPurple10,
  primaryMain: migWizPurple,
  primaryDark: migWizPurpleDark,
  secondaryLight: migWizPurple3,
  secondaryMain: migWizPurple30,
  secondaryDark: migWizPurpleHalfDark,
  errorLight: redLight,
  errorMain: redMedium,
  errorDark: redDark,
  warningLight: warningLight,
  warningMain: warningMedium,
  warningDark: warningDark,
  infoLight: infoLight,
  infoMain: infoMedium,
  infoDark: infoDark,
  successLight: successLight,
  successMain: successMedium,
  successDark: successDark,
  grey50,
  grey100,
  grey200,
  grey300,
  grey400,
  grey500,
  grey600,
  grey700,
  grey800,
  grey900,
  redExtraDark,
  migWizPurple50,
  chart3Queued,
  chart4WaitingForUser,
  stepperBarFill,
  black,
  white,
};

export default colors;
